import { useCallback } from "react";
import BackGroundService from "../../services/background";
import { DOCX_TYPE } from "../constants";
import { FormInstance } from "antd";

export const useGetTaskGenerateReport = (
  form: FormInstance,
  setGlobalIsLoading: (value: boolean) => void,
  setError: (value: string[]) => void,
  onFail: () => void
) => {
  const getStatus = useCallback(
    async (id: string) => {
      try {
        const res = await BackGroundService.getProgress(id);

        const { status, result } = res;

        if ([6, 4].includes(status)) {
          if (status === 4) {
            if (result.succesfulCount === 1) {
              setGlobalIsLoading(false);

              const value = {
                response: result.additionalData.ResultFileItemId,
                name: result.additionalData.ResultFileName,
                type: DOCX_TYPE,
                status: "done",
                size: result.additionalData.ResultFileSizeBytes,
                taskId: id,
                id,
              };

              form.setFieldValue("fileList", [value]);
            } else {
              setGlobalIsLoading(false);

              setError(["Generation failed"]);
            }
          }

          status === 6 && onFail();
        } else {
          setTimeout(async () => {
            await getStatus(id);
          }, 1000);
        }
      } catch {
        onFail();
      }
    },
    [form, onFail, setError, setGlobalIsLoading]
  );

  return { getStatus };
};
